import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './utils/PrivateRoute';
import PublicRoute from './utils/PublicRoute';
import ScrollToTop from './utils/ScrollToTop';
import ThemeWrapper from './utils/ThemeWrapper';
import { AuthProvider } from './context/AuthContext';
import Home from './pages/Home';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiesPolicy from './pages/CookiesPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import SignUpRedirect from './pages/SignUpRedirect';
import ActivateUser from './pages/ActivateUser';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import GitHubOAuthCallback from './pages/GitHubOAuthCallback';
import Settings from './pages/Settings';
import Dashboard from './pages/Dashboard';
import ProblemSets from './pages/ProblemSets';
import Problem from './pages/Problem';
import NotFound from './pages/NotFound'
import Maintenance from './pages/Maintenance';
import {
  HOME_ROUTE,
  ABOUT_ROUTE,
  PRIVACY_POLICY_ROUTE,
  COOKIES_POLICY_ROUTE,
  TERMS_AND_CONDITIONS_ROUTE,
  LOGIN_ROUTE,
  SIGN_UP_ROUTE,
  SIGN_UP_REDIRECT_ROUTE,
  ACTIVATE_USER_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  RESET_PASSWORD_ROUTE,
  GITHUB_OAUTH_CALLBACK_ROUTE,
  SETTINGS_ROUTE,
  DASHBOARD_ROUTE,
  PROBLEM_SETS_ROUTE,
  PROBLEM_ROUTE,
  MAINTENANCE_MODE
} from './config/constants';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';

const App = (): JSX.Element | null => {
  if (MAINTENANCE_MODE) {
    return (
      <div className='App'>
        <ThemeProvider>
          <ThemeWrapper>
            <AuthProvider>
              <Routes>
                <Route
                  path={'*'}
                  element={
                    <PublicRoute>
                      <Maintenance />
                    </PublicRoute>
                  }
                />
              </Routes>
            </AuthProvider>
          </ThemeWrapper>
        </ThemeProvider>
      </div>
    )
  }

  return (
    <div className='App'>
      <ScrollToTop />
      <ThemeProvider>
        <ThemeWrapper>
          <AuthProvider>
            <Routes>
                <Route
                  path={HOME_ROUTE}
                  element={
                    <PublicRoute>
                      <Home />
                    </PublicRoute>
                  }
                />
                <Route
                  path={ABOUT_ROUTE}
                  element={
                    <PublicRoute>
                      <About />
                    </PublicRoute>
                  }
                />
                <Route
                  path={PRIVACY_POLICY_ROUTE}
                  element={
                    <PublicRoute>
                      <PrivacyPolicy />
                    </PublicRoute>
                  }
                />
                <Route
                  path={COOKIES_POLICY_ROUTE}
                  element={
                    <PublicRoute>
                      <CookiesPolicy />
                    </PublicRoute>
                  }
                />
                <Route
                  path={TERMS_AND_CONDITIONS_ROUTE}
                  element={
                    <PublicRoute>
                      <TermsAndConditions />
                    </PublicRoute>
                  }
                />
                <Route
                  path={LOGIN_ROUTE}
                  element={
                    <PublicRoute>
                      <Login />
                    </PublicRoute>
                  }
                />
                <Route
                  path={SIGN_UP_ROUTE}
                  element={
                    <PublicRoute>
                      <SignUp />
                    </PublicRoute>
                  }
                />
                <Route
                  path={SIGN_UP_REDIRECT_ROUTE}
                  element={
                    <PublicRoute>
                      <SignUpRedirect />
                    </PublicRoute>
                  }
                />
                <Route
                  path={ACTIVATE_USER_ROUTE}
                  element={
                    <PublicRoute>
                      <ActivateUser />
                    </PublicRoute>
                  }
                />
                <Route
                  path={FORGOT_PASSWORD_ROUTE}
                  element={
                    <PublicRoute>
                      <ForgotPassword />
                    </PublicRoute>
                  }
                />
                <Route
                  path={RESET_PASSWORD_ROUTE}
                  element={
                    <PublicRoute>
                      <ResetPassword />
                    </PublicRoute>
                  }
                />
                <Route
                  path={GITHUB_OAUTH_CALLBACK_ROUTE}
                  element={
                    <PublicRoute>
                      <GitHubOAuthCallback />
                    </PublicRoute>
                  }
                />
                <Route
                  path={SETTINGS_ROUTE}
                  element={
                    <PrivateRoute>
                      <Settings />
                    </PrivateRoute>
                  }
                />
                <Route
                  path={DASHBOARD_ROUTE}
                  element={
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  }
                />
                <Route
                  path={PROBLEM_SETS_ROUTE}
                  element={
                    <PublicRoute>
                      <ProblemSets />
                    </PublicRoute>
                  }
                />
                <Route
                  path={PROBLEM_ROUTE}
                  element={
                    <PublicRoute>
                      <Problem />
                    </PublicRoute>
                  }
                />
                <Route
                  path={'*'}
                  element={
                    <PublicRoute>
                      <NotFound />
                    </PublicRoute>
                  }
                />
            </Routes>
          </AuthProvider>
        </ThemeWrapper>
      </ThemeProvider>
    </div>
  );
}

export default App;
